import type { SupportedLanguage } from '@moneytome/shared';

const storageKey = 'moneyto:promo-language';

export function readLanguagePreference(): SupportedLanguage {
  try {
    return localStorage.getItem(storageKey) === 'kk' ? 'kk' : 'ru';
  } catch {
    return 'ru';
  }
}

export function saveLanguagePreference(language: string): void {
  if (language !== 'ru' && language !== 'kk') return;
  try {
    localStorage.setItem(storageKey, language);
  } catch {
    // The active language still works when browser storage is unavailable.
  }
}
